import { Directive, Injectable } from '@angular/core';
import { BarraConsultaMensalComponent } from './barra-consulta-mensal.component';

@Injectable(
    {
        providedIn: 'root'
    }
)
@Directive()
export class BarraConsultaMensalService extends BarraConsultaMensalComponent {

}


